__turbopack_context__.v({
  "body": "mochi-modal-module-scss-module__SfOxpG__body",
  "close": "mochi-modal-module-scss-module__SfOxpG__close",
  "content": "mochi-modal-module-scss-module__SfOxpG__content",
  "dark-mode": "mochi-modal-module-scss-module__SfOxpG__dark-mode",
  "default": "mochi-modal-module-scss-module__SfOxpG__default",
  "dialog-layout": "mochi-modal-module-scss-module__SfOxpG__dialog-layout",
  "footer": "mochi-modal-module-scss-module__SfOxpG__footer",
  "full": "mochi-modal-module-scss-module__SfOxpG__full",
  "header": "mochi-modal-module-scss-module__SfOxpG__header",
  "light-mode": "mochi-modal-module-scss-module__SfOxpG__light-mode",
  "show": "mochi-modal-module-scss-module__SfOxpG__show",
});
